import { eq } from 'drizzle-orm'
import {
  accountingTransactionTable,
  assetBalanceTable,
  assetBorrowTable,
  crossActionBundleTable,
  loanTable,
  nftAcquiredTimestampTable,
} from '../schema'
import type { DatabaseWithTransaction } from '../types'

type ResetAccountingPeriodDataParameters = {
  database: DatabaseWithTransaction
  accountingPeriodId: number
}

export const resetAccountingPeriodData = async ({
  database: { transaction },
  accountingPeriodId,
}: ResetAccountingPeriodDataParameters) => {
  await transaction([
    (tx) => [
      // asset balance
      tx
        .delete(assetBalanceTable)
        .where(eq(assetBalanceTable.accountingPeriodId, accountingPeriodId)),
      // asset borrow
      tx
        .delete(assetBorrowTable)
        .where(eq(assetBorrowTable.accountingPeriodId, accountingPeriodId)),
      // nft acquired timestamp
      tx
        .delete(nftAcquiredTimestampTable)
        .where(
          eq(nftAcquiredTimestampTable.accountingPeriodId, accountingPeriodId),
        ),
      // accounting transaction
      tx
        .delete(accountingTransactionTable)
        .where(
          eq(accountingTransactionTable.accountingPeriodId, accountingPeriodId),
        ),
      // loan
      tx
        .delete(loanTable)
        .where(eq(loanTable.accountingPeriodId, accountingPeriodId)),
      // cross action bundle
      tx
        .delete(crossActionBundleTable)
        .where(
          eq(crossActionBundleTable.accountingPeriodId, accountingPeriodId),
        ),
    ],
  ])
}
